import React from 'react'
import PropTypes from "prop-types";

import { CatalogIcon } from 'src/assets/svg/project-detail';
import IconArrowGreen from "assets/svg/chevron_right_green.svg";

import styles from "./styles.module.css";

const ProjectCatalog = ({ projectName, catalogUrl }) => {
  return (
    <a 
     className={styles.wrapper} href={catalogUrl} rel='nofollow'>
      <div className={styles.innerContainer}> 
        <div className={styles.catalogInfo}>
            <CatalogIcon />
            <p>{`${projectName}`} proje kataloğunu<span className={styles.catalogText}> görüntülemek için tıklayın.</span></p>
        </div>
        <div className={styles.icon}>
        <IconArrowGreen />
        </div>
      </div>
    </a>
  )
}

ProjectCatalog.propTypes = {
  projectName: PropTypes.string,
  catalogUrl: PropTypes.string,
};

export default ProjectCatalog;
